/** Hint beside the HQLead row of the Meta routing table (TASK-234, S8; wording v2: TASK-253, S16). */
export function HqMetaRowHint({ eventType }: { eventType: string }) {
  if (eventType !== "HQLead") return null;
  return (
    <span
      className="ml-1 font-sans text-text-tertiary"
      title="Der Haken an HQLead meldet ein eigenes Ereignis „HQLead“ an Meta. Nur HQ-Leads als Lead stellst du an der Datenquelle bzw. Seiten-Regel ein."
    >
      · eigenes Ereignis HQLead an Meta
    </span>
  );
}

/**
 * Sentence under the table: the table means what it says, "only HQ leads as Lead"
 * is a per-source switch (TASK-253, S16).
 */
export function OnlyHqNotice() {
  return (
    <p className="mt-2 rounded-md border border-border-secondary bg-bg-tertiary px-3 py-2 text-xs text-text-secondary">
      Nur HQ-Leads als Lead an Meta stellst du an der Datenquelle bzw. Seiten-Regel ein.
    </p>
  );
}
